<!--
 * @Author: scg
 * @Date: 2022-01-20 10:40:31
 * @LastEditTime: 2022-01-20 11:12:50
 * @LastEditors: scg
 * @Description:
-->
<template>
  <el-popover
    trigger="click"
    class="language-popover"
    popper-class="language-popper"
    :popup-visible="popupVisible"
  >
    <div slot="reference" class="language" @click.stop="">
      <!-- <img
        class="icon"
        style="display: none"
        src="@/assets/img/locales/Union.png"
      /> -->
      <!-- <img class="icon" src="@/assets/img/locales/Union-2.png" /> -->
      <span class="text">{{ $t(localeName) }}</span>
      <!-- <img class="arrow" src="@/assets/img/locales/cell_arrow_right.png" /> -->
      <i
        v-if="!popupVisible"
        :style="{ color: '#999', fontSize: '16px' }"
        class="el-icon-caret-bottom"
      ></i>
      <i
        v-else
        :style="{ color: '#999', fontSize: '16px' }"
        class="el-icon-caret-top"
      ></i>
    </div>
    <div class="list">
      <div
        :class="['item', $i18n.locale === item.code ? 'select' : '']"
        v-for="(item, index) in locales"
        :key="index"
        @click="setLocale(item)"
      >
        {{ $t(item.name) }}
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  data() {
    return {
      popupVisible: false,
      selectedLocale: {
        name: "11",
      },
      locales: [
        {
          code: "en",
          name: "English",
          iso: "en",
          arcoKey: "enUS",
        },
        {
          code: "de",
          name: "German", //德语
          iso: "de",
          arcoKey: "deDE",
        },
        {
          code: "es",
          name: "Spanish", // 西班牙语
          iso: "es",
          arcoKey: "esES",
        },
        {
          code: "fr",
          name: "French", //法语
          iso: "fr",
          arcoKey: "frFR",
        },
        {
          code: "br",
          name: "Portuguese", //葡萄牙语
          iso: "br",
          arcoKey: "ptPT",
        },
        {
          code: "tr",
          name: "Turkish", // 土耳其语
          iso: "tr",
          arcoKey: "enUS",
        },
        {
          code: "it",
          name: "Italian", //意大利语
          iso: "it",
          arcoKey: "itIT",
        },
        {
          code: "jp",
          name: "Japanese", // 日语
          iso: "jp",
          arcoKey: "jaJP",
        },
        {
          code: "ar",
          name: "Arabic", // 阿拉伯语
          iso: "ar",
          arcoKey: "arEG",
        },
      ],
    };
  },
  computed: {
    localeName() {
      return this.locales.find((item) => item.code === this.$i18n.locale).name;
    },
  },
  mounted() {
    let locale = localStorage.getItem("locale");
    console.log(this.$i18n.locale);
  },
  methods: {
    setLocale(item) {
      document.documentElement.setAttribute("lang", item.code);
      this.$i18n.locale = item.code;
      localStorage.setItem("locale", item.code);
      location.reload();
    },
  },
};
</script>

<style scoped>
.language-popover {
  float: right;
  height: 60px;
  display: flex;
  align-items: center;
  min-width: 110px;
}

.language-popover .el-popover__reference-wrapper {
  display: inline-block;
  height: 100%;
  line-height: 100%;
}
.language {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0;
  padding: 0;
  min-width: 80px;
  cursor: pointer;
  font-family: Noto Sans !important;
}
.language .icon {
  width: 16px;
  height: 16px;
}
.language .text {

  font-size: 14px;
  font-weight: 400;
  font-family: Noto Sans !important;
  margin: 0 4px;
  color: #000000;
  /* color: #ffffff; */
}
.language .arrow {
  width: 16px;
  height: 16px;
}
.list {
}
.list .item {
  cursor: pointer;
  font-family: Noto Sans !important;
  width: 96px;
  height: 38px;
  background: #fff;
  border-radius: 2px;
  font-size: 14px;
  font-family: Poppins, Poppins;
  font-weight: 400;
  color: #000;
  text-align: center;
  line-height: 38px;
}
.list .item:hover {
  background: #00eec347;
  /* color: var(--Primary-1); */
}
.list .select {
  background: #00eec347;
  font-weight: 400;
  color: #000;
}
@media screen and (orientation: portrait) {
  .language .text {
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/languageTranslation.vue